import "UI/Widget/Base";
NS("Glonass.UI");

Glonass.UI.MenuItem = Class(UI.Widget.Base, {
    template: "Glonass/MenuForm/Item",

    name: null,
    color: null,
    icon: null,
    title: null,

    onClick: function() {
        this.emit("click", {
            item: this
        });
    }
});